var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-menu', {
    attrs: {
      "default-active": _vm.$route.path,
      "mode": "vertical",
      "unique-opened": "",
      "background-color": "#1C1E2F",
      "text-color": "#4C5275",
      "active-text-color": "#fff"
    }
  }, [_c('sidebar-item', {
    attrs: {
      "routes": _vm.routes
    }
  })], 1)
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-092b51fe", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-092b51fe","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/layout/Sidebar.vue
// module id = NI3s
// module chunks = 1